import { render, staticRenderFns } from "./ReviewText.vue?vue&type=template&id=5c940e30&functional=true&"
import script from "./ReviewText.vue?vue&type=script&lang=js&"
export * from "./ReviewText.vue?vue&type=script&lang=js&"
import style0 from "./ReviewText.vue?vue&type=style&index=0&id=5c940e30&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports